import type { ReactNode } from 'react';
import './Card.css';

export interface CardProps {
  title?: string;
  description?: string;
  image?: string;
  footer?: ReactNode;
  children?: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Card = ({
  title,
  description,
  image,
  footer,
  children,
  className = '',
  onClick,
}: CardProps) => {
  return (
    <div className={`card ${className}`} onClick={onClick}>
      {image && (
        <img src={image} alt={title || 'Card image'} className="card__image" />
      )}

      {(title || description || children) && (
        <div className="card__content">
          {title && <h3 className="card__title">{title}</h3>}
          {description && <p className="card__description">{description}</p>}
          {children}
        </div>
      )}

      {footer && <div className="card__footer">{footer}</div>}
    </div>
  );
};
